import { render, staticRenderFns } from "./NotificationConfig.vue?vue&type=template&id=6b37cdf6&scoped=true&"
import script from "./NotificationConfig.vue?vue&type=script&lang=js&"
export * from "./NotificationConfig.vue?vue&type=script&lang=js&"
import style0 from "./NotificationConfig.vue?vue&type=style&index=0&id=6b37cdf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b37cdf6",
  null
  
)

export default component.exports